export enum ContractServicePeriod {
    spAny = 0,
    spWeek = 1,
    spMonth1 = 2,
    spMonth2 = 3,
    spMonth3 = 4,
    spMonth6 = 5,
    spYear = 6,
    spDays = 7
}